import menuIcon from "assets/icons/MenuIcon.svg";
import StoreButton from "components/Common/Navigation/StoreButton";
import FavoritesButton from "components/Common/Navigation/FavoritesButton";
import heartRoundedIcon from "assets/icons/heartroundedIcon.svg";
import { useAuthStore } from "stores/auth/authStore";
import { useCartStore } from "stores/cart/useCartStore";

export default function MdScreenButtons({onSignInHandler,onSignUpHandler, favouriteSaddleData}) {
    const user = useAuthStore((state) => state.user);
    const toggle = useAuthStore((state) => state.toggle);
    const setToggle = useAuthStore((state) => state.setToggle);
    const userCartData = useCartStore((state) => state.userCartData);
    const filteredItems = userCartData?.items?.filter(
        (item) => item?.productData?.status === "SELL_LIVE"
      );
  return (
    <div className="lg:hidden flex items-center gap-5">
    {!user && (
      <div className="hidden sm:flex flex-row gap-x-6">
        <button
          onClick={onSignInHandler}
          className="w-auto h-[54px] px-6 bg-[#F7F7F6] text-[#1f2937] rounded-[150px] hover:bg-gray-100 transition-colors text-[18px] font-medium font-montserrat"
        >
          Sign In
        </button>
        <button
          onClick={onSignUpHandler}
          className="w--auto h-[54px] px-6 border border-white bg-transparent text-white rounded-[150px] hover:bg-white/10 transition-colors text-[18px] font-medium font-montserrat"
        >
          Join now
        </button>
      </div>
    )}
    {user && (
      <>
        <div className="relative">
          <StoreButton
            className={"text-transparent bg-transparent"}
          />
          {filteredItems?.length > 0 && (
            <div className="bg-red-500 w-6 h-6 text-[12px] cartItemNumber rounded-full  text-white absolute top-[-16px] right-[-18px] flex justify-center items-center">
              {filteredItems?.length}
            </div>
          )}
        </div>
        <div className="relative">
          <FavoritesButton
            className={"text-transparent bg-transparent"}
          />
          {favouriteSaddleData?.listSaddleFavorites?.length > 0 && (
            <img
              src={heartRoundedIcon}
              alt="heartRoundedIcon"
              className="absolute top-0 right-[-2px]"
            />
          )}
        </div>
      </>
    )}

    <img
      alt="menu-icon"
      src={menuIcon}
      onClick={(e) => {
        e.stopPropagation();
        setToggle(!toggle);
      }}
      className="menu-icon cursor-pointer duration-200"
    />
  </div>


) 
}